//import React from 'react';
import { styled } from '@material-ui/core/styles';
import OriButton from '@material-ui/core/Button';

export const Button = styled(OriButton)({
    textTransform: 'none'
});
